import {
  getFindPersonDetailsQueryKey,
  mapContactCardType,
  useCreateContactCard as useCreateContactCardMutation,
} from '@api';
import { useInvalidateQuery, useNotification } from '@common';
import { isAxiosError } from 'axios';

const TRANS_KEY = 'NOTIFICATIONS.CREATE_CONTACT_CARD';

type UseCreateContactCardArgsType = {
  personId: string;
};

type CreatedContactCardType = NonNullable<
  ReturnType<typeof mapContactCardType>
>;

type UseCreateContactCardReturnType = {
  createContactCard: (
    companyLinkId: string
  ) => Promise<CreatedContactCardType | null>;
  isCreateContactCardPending: boolean;
};

export const useCreateContactCard = ({
  personId,
}: UseCreateContactCardArgsType): UseCreateContactCardReturnType => {
  const { mutateAsync, isPending } = useCreateContactCardMutation();
  const { showError } = useNotification();
  const { invalidateQuery } = useInvalidateQuery(
    getFindPersonDetailsQueryKey(personId)
  );

  const createContactCard = async (
    companyLinkId: string
  ): Promise<CreatedContactCardType | null> => {
    try {
      const response = await mutateAsync({ companyLinkId });
      await invalidateQuery();
      return mapContactCardType(response.data);
    } catch (error) {
      if (isAxiosError(error)) {
        showError({
          title: `${TRANS_KEY}.ERROR.TITLE`,
          message: `${TRANS_KEY}.ERROR.MESSAGE`,
          error,
        });
      }

      return null;
    }
  };

  return {
    createContactCard,
    isCreateContactCardPending: isPending,
  };
};
